import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const payInvoice = ({
  invoiceId,
  paymentMethod,
  reservationId,
  saleId,
  amount,
}) => {
  return mutateApi({
    url: `/account/invoice_payment/${invoiceId}/pay`,
    method: "POST",
    data: {
      payment_method_id: paymentMethod,
      reservation_id: reservationId,
      sale_id: saleId,
      amount,
    },
  })
}

export const getInvoice = ({ invoiceId }) => {
  return queryApi(`/account/invoice_payment/${invoiceId}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}
